import { latestEvidence, type EvidenceItem } from '@/mocks/homeData';
import SectionHead from './SectionHead';

const toneMap: Record<EvidenceItem['kindTone'], { badge: string; bar: string }> = {
  primary: { badge: 'bg-primary-100 text-primary-800', bar: 'bg-primary-500' },
  accent: { badge: 'bg-accent-100 text-accent-900', bar: 'bg-accent-500' },
  secondary: { badge: 'bg-secondary-100 text-secondary-900', bar: 'bg-secondary-500' },
};

export default function LatestEvidence() {
  return (
    <section id="zui-xin" className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <SectionHead
          index="档案 01"
          kicker="今日最新实锤"
          title="刚被收进档案的新线索"
          desc="更新越靠前，核验进度越完整。每一张封面都对应一套可展开查看的原始证据包。"
        />
        <a
          href="#shen-du"
          className="flex h-10 shrink-0 items-center justify-center rounded-md border border-foreground-200 px-4 text-sm text-foreground-700 whitespace-nowrap transition-colors duration-200 hover:border-primary-300 hover:text-primary-700 cursor-pointer"
        >
          查看往期全部档案
          <i className="ri-arrow-right-up-line ml-1.5" aria-hidden="true"></i>
        </a>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {latestEvidence.map((item) => {
          const tone = toneMap[item.kindTone];
          return (
            <article key={item.title} className="group overflow-hidden rounded-lg bg-background-100">
              <a href="#zui-xin" className="block cursor-pointer">
                <div className="relative overflow-hidden">
                  <div className="aspect-[4/3] w-full">
                    <img
                      src={item.cover}
                      alt={item.coverAlt}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <span
                    className={`absolute left-3 top-3 flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-semibold ${tone.badge}`}
                  >
                    <i className={item.kindIcon} aria-hidden="true"></i>
                    {item.kind}
                  </span>
                </div>
              </a>

              <div className="p-5">
                <div className="flex items-center gap-2">
                  <span className={`h-1 w-4 rounded-full ${tone.bar}`}></span>
                  <span className="text-xs text-foreground-500">{item.updated}</span>
                </div>
                <a href="#zui-xin" className="mt-2 block cursor-pointer">
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors duration-200 group-hover:text-primary-700">
                    {item.title}
                  </h3>
                </a>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.excerpt}</p>

                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-file-copy-2-line" aria-hidden="true"></i>
                    {item.files} 份证据文件
                  </span>
                  <span className="flex items-center gap-1.5 rounded-full bg-primary-50 px-2.5 py-1 text-xs text-primary-700">
                    <i className="ri-shield-check-line" aria-hidden="true"></i>
                    {item.status}
                  </span>
                </div>

                <div className="mt-4">
                  <a
                    href="#zui-xin"
                    className="flex h-10 items-center justify-center gap-1.5 rounded-md border border-foreground-200 text-sm text-foreground-800 whitespace-nowrap transition-colors duration-200 hover:border-primary-400 hover:bg-primary-50 hover:text-primary-700 cursor-pointer"
                  >
                    查看证据包
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}